import { ID, Timestamp } from '@griply/types';

export const formatIdDateKey = (
  taskId: ID,
  date?: Timestamp,
  duration?: number,
) => [taskId, date?.getTime(), duration].filter(Boolean).join('--');

export const parseIdDateKey = (key: ID) => {
  const [id, date, duration] = key.split('--');
  return {
    id,
    date: date ? new Date(Number(date)) : undefined,
    duration: duration ? Number(duration) : undefined,
  };
};
